let store = {_axiosPromiseCancel: [] };
export default store;